export default __webpack_public_path__ + "static/media/icon-1.cad58646.png";